/**
 * 内容文案日译表（中文原文 → 日本語）。规则同 CONTENT_EN。
 */
export const CONTENT_JA = {
  '永远元气满满的乐天派，用漫天弹幕把快乐撒向全屏。': 'いつも元気いっぱいの楽天家。弾幕と一緒に笑顔を画面いっぱいにまき散らす。',
  '戴着墨镜的冷酷射手，弹无虚发，人狠话不多。': 'サングラスのクールな射手。弾は百発百中、口数は少ない。',
  '一点就着的暴脾气，火球所到之処寸草不生。': 'すぐキレる短気者。火球の通った後には草も生えない。',
  '爱哭的软妹子，眼泪会自己找到敌人，护盾悄悄守护她。': '泣き虫な女の子。涙は勝手に敵を探し、盾がそっと見守る。',
  '满脸问号的迷之存在，弹道和敌人一起陷入混乱。': 'クエスチョンマークだらけの謎の存在。弾道も敵も一緒に混乱へ。',
  '热血应援团长，环绕子机就是她的啦啦队。': '熱血応援団長。周回オプションは彼女のチアリーダー。',
  '永远睡不醒的重炮手，醒来的一炮惊天动地。': 'いつも眠そうな重砲手。目覚めの一発は天地を揺るがす。',
  '卖萌担当，连子弹都是爱你的形状。': '可愛さ担当。弾まで愛の形。',
  '开心散射': 'ハッピースプレッド',
  '扇形散射，火力提升增加弹道（3→7 向），低速收束': '扇形拡散。火力アップで弾道増加（3→7 方向）、低速で収束',
  '酷穿双枪': '貫通ツインガン',
  '窄直线贯通弹，火力提升追加斜向副炮': '細い直線貫通弾。火力アップで斜め副砲追加',
  '怒火三连': 'トリプルレイジ',
  '贯通火球，火力提升增加弹道（1→5 向），低速合成重击': '貫通火球。火力アップで弾道増加（1→5 方向）、低速で重撃に合体',
  '泪之诱导': '涙の誘導',
  '自动追踪敌人的泪弹，火力提升增加连发数': '敵を自動追尾する涙弾。火力アップで連発数増加',
  '迷惑散射': '混乱スキャッター',
  '随机角度散射，火力提升增加弹数': 'ランダム角度拡散。火力アップで弾数増加',
  '应援直线弹': '応援ストレート',
  '直线弹 + 环绕子机，火力提升增加子机数': '直線弾 + 周回オプション。火力アップでオプション増加',
  '瞌睡重炮': '居眠りキャノン',
  '大弹高伤炮，火力提升追加副炮，低速伤害再加成': '大型高火力砲。火力アップで副砲追加、低速でダメージさらにアップ',
  '爱心扩散': 'ハートスプレッド',
  '心形扩散弹，火力提升增加弹数': 'ハート型拡散弾。火力アップで弾数増加',
  '满天烟花': '満天の花火',
  '贯穿主炮': '貫通メインキャノン',
  '以自机为中心的纵激光柱，持续 1.5s': '自機中心の縦レーザー柱。1.5 秒持続',
  '震爆': 'ショックブラスト',
  '全屏伤敌 + 剧烈震屏 + 清弹': '画面全体ダメージ + 激しい画面振動 + 弾消し',
  '泪之护盾': '涙のシールド',
  '清弹 + 10s 内挡下一次中弹': '弾消し + 10 秒以内に被弾を一度防ぐ',
  '混乱力场': '混乱フィールド',
  '清弹 + 敌机 5s 内射击错乱（射速减半）': '弾消し + 敵機の射撃が 5 秒間混乱（連射半減）',
  '应援结界': '応援結界',
  '梦境领域': '夢境領域',
  '大范围清弹 + 敌机睡眠 3s（不射弹）': '広範囲弾消し + 敵機が 3 秒間睡眠（射撃停止）',
  '爱心爆发': 'ハートバースト',
  '无敌冲刺': '無敵ダッシュ',
  '2.5s 无敌 + 移速提升 + 接触伤敌': '2.5 秒無敵 + 移動速度アップ + 接触ダメージ',
  '子弹时间': 'バレットタイム',
  '全场时间 0.35×，持续 2.5s': '全体の時間が 0.35 倍に。2.5 秒持続',
  '狂暴': 'ベルセルク',
  '大哭': '大泣き',
  '全力应援': '全力応援',
  '魅惑': '魅惑',
  '屏上敌弹变点道具（上限 200）+ 3s 无敌': '画面の敵弾を点アイテムに（上限 200）+ 3 秒無敵',
  '无敌冲刺！': '無敵ダッシュ！',
  '狂暴！！': 'ベルセルク！！',
  '护盾展开': 'シールド展開',
  '加油！加油！': 'ファイト！ファイト！',
  '云端·天空': '雲上・天空',
  '深海·水压': '深海・水圧',
  '齿轮·机械': '歯車・機械',
  '腐叶·森林': '腐葉・森林',
  '幽影·暗界': '幽影・闇界',
  '星界·终焉': '星界・終焉',
  '终焉回廊': '終焉の回廊',
  'STAGE 1  云端·天空': 'STAGE 1  雲上・天空',
  'STAGE 2  深海·水压': 'STAGE 2  深海・水圧',
  'STAGE 3  齿轮·机械': 'STAGE 3  歯車・機械',
  'STAGE 4  腐叶·森林': 'STAGE 4  腐葉・森林',
  'STAGE 5  幽影·暗界': 'STAGE 5  幽影・闇界',
  'STAGE 6  星界·终焉': 'STAGE 6  星界・終焉',
  'STAGE 1 · 测试关': 'STAGE 1 · テスト',
  'STAGE 2 · 测试关': 'STAGE 2 · テスト',
  'STAGE 3 · 测试关': 'STAGE 3 · テスト',
  'STAGE 4 · 测试关': 'STAGE 4 · テスト',
  'STAGE 5 · 测试关': 'STAGE 5 · テスト',
  'STAGE 6 · 测试关': 'STAGE 6 · テスト',
  '测试关：正式关卡脚本就位后将替换本关': 'テストステージ：正式スクリプト完成後に差し替え',
  '警告：强大的气息接近了……': '警告：強大な気配が近づいている……',
  '第一形态': '第一形態',
  '狂暴形态': '狂暴形態',
  '风暴精灵': '嵐の精霊',
  '云端的中枢': '雲上の中枢',
  '积雨云之王': '積乱雲の王',
  '天空的支配者': '天空の支配者',
  '深海灯笼鱼': '深海アンコウ',
  '水压的引路者': '水圧の案内人',
  '深渊克拉肯': '深淵のクラーケン',
  '深海的主宰': '深海の主',
  '哨戒机': '哨戒機',
  '齿轮回廊的守卫': '歯車回廊の番人',
  '核心熔炉': 'コア熔炉',
  '机械城的心脏': '機械城の心臓',
  '孢子菇后': '胞子キノコ后',
  '腐叶林的女王': '腐葉林の女王',
  '千年树人': '千年の樹人',
  '森林的古老意志': '森の古き意志',
  '提灯鬼': '提灯鬼',
  '暗界的引魂人': '闇界の魂案内人',
  '虚无之眼': '虚無の目',
  '暗界尽头的凝视': '闇界の果ての凝視',
  '彗星骑士': '彗星の騎士',
  '星界的先锋': '星界の先鋒',
  '星尘核心': '星屑のコア',
  '终焉之核': '終焉の核',
  '星灵': '星の精霊',
  '终焉回廊的支配者': '終焉の回廊の支配者',
  '旋风': '旋風',
  '积雨压顶': '積雲圧頂',
  '雷电走线': '雷電の配線',
  '诱光': '誘いの光',
  '触手横扫': '触手の横薙ぎ',
  '墨云': '墨の雲',
  '触手狂乱': '触手の狂乱',
  '警戒扫描': '警戒スキャン',
  '齿轮齐射': '歯車の斉射',
  '冲压墙': 'プレス壁',
  '蒸汽喷发': '蒸気の噴発',
  '孢子散播': '胞子の散布',
  '菌丝缠绕': '菌糸の絡み',
  '落叶': '落ち葉',
  '花粉风暴': '花粉の嵐',
  '千年之怒': '千年の怒り',
  '鬼火引诱': '鬼火の誘い',
  '奇袭': '奇襲',
  '凝视': '凝視',
  '加速突袭': '加速突撃',
  '瞳孔收缩': '瞳孔収縮',
  '彗星冲锋': '彗星の突撃',
  '骑士连击': '騎士の連撃',
  '星尘散弹': '星屑の散弾',
  '弹幕变换': '弾幕変化',
  '终焉流星雨': '終焉の流星群',
  '乱流': '乱気流',
  '暗流': '暗流',
  '链齿': 'チェーンギア',
  '风切': 'ウィンドシアー',
  '云海': '雲海',
  '暗涌': '暗きうねり',
  '铆钉连射': 'リベット連射',
  '荆棘': '茨',
  '暗雨': '闇の雨',
  '星尘壁垒': '星屑の防壁',
  '风符「旋涡气流」': '風符「渦の気流」',
  '云符「积雨乱打」': '雲符「積雨乱打」',
  '岚符「天罚风暴」': '嵐符「天罰の嵐」',
  '灯符「深海诱光」': '灯符「深海の誘光」',
  '涡符「大漩涡」': '渦符「大渦巻」',
  '泡符「深渊呼吸」': '泡符「深淵の呼吸」',
  '锁符「回旋封锁」': '鎖符「回旋封鎖」',
  '链符「定时连锁」': '鎖符「定時連鎖」',
  '炉符「超临界炉心」': '炉符「超臨界炉心」',
  '孢符「风媒飞孢」': '胞符「風媒の飛胞」',
  '藤符「封位蔓牢」': '藤符「封位の蔓牢」',
  '根符「大地脉动」': '根符「大地の脈動」',
  '灯符「鬼火提灯」': '灯符「鬼火の提灯」',
  '暗符「无光之海」': '闇符「無光の海」',
  '眼符「虚空凝视」': '眼符「虚空の凝視」',
  '虚符「虚无降临」': '虚符「虚無の降臨」',
  '彗符「星尘尾迹」': '彗符「星屑の尾跡」',
  '星符「银河回旋」': '星符「銀河の回旋」',
  '核符「超新星爆发」': '核符「超新星爆発」',
  '星符「宇宙收缩」': '星符「宇宙の収縮」',
  '壹符「星屑迎撃」': '壱符「星屑迎撃」',
  '贰符「流星追尾」': '弐符「流星追尾」',
  '叁符「十字激光阵」': '参符「十字レーザー陣」',
  '肆符「曲线回廊」': '肆符「曲線の回廊」',
  '伍符「加速乱舞」': '伍符「加速の乱舞」',
  '陆符「菌毯蔓延」': '陸符「菌絨毯の蔓延」',
  '柒符「蛇形矩阵」': '漆符「蛇行マトリクス」',
  '捌符「终焉·全弹发射」': '捌符「終焉・全弾発射」',
  '飓符「台风眼壁」': '颶符「台風の目の壁」',
  '渊符「深海沉光」': '淵符「深海の沈光」',
  '锯符「回旋锯阵」': '鋸符「回旋ノコギリ陣」',
  '茸符「菌毯爆发」': '茸符「菌絨爆発」',
  '影符「百鬼夜行」': '影符「百鬼夜行」',
  '陨符「陨星碎击」': '隕符「隕星の砕撃」',
  '雷符「轰雷阵」': '雷符「轟雷の陣」',
  '旋符「大旋风」': '旋符「大旋風」',
  '潮符「怒涛压境」': '潮符「怒涛の圧境」',
  '漩符「螺旋海流」': '漩符「螺旋の海流」',
  '导符「制导导弹」': '導符「誘導ミサイル」',
  '齿符「飞散齿轮」': '歯符「飛散する歯車」',
  '叶符「翠叶旋舞」': '葉符「翠葉の旋舞」',
  '精符「森之精魄」': '精符「森の精魄」',
  '灭符「永夜降临」': '滅符「永夜の降臨」',
  '煌符「星火燎原」': '煌符「星火燎原」',
  '玖符「星链锁阵」': '玖符「星鎖の陣」',
  '拾符「终焉·星灵全开」': '拾符「終焉・星霊全開」',
  '月下的开幕礼': '月下の開幕式',
  '标题画面主题曲': 'タイトル画面のテーマ',
  '云海散步道': '雲海の散歩道',
  '第一关·云端主题曲': '第 1 面・雲上のテーマ',
  '深蓝摇篮': '深藍の揺りかご',
  '第二关·深海主题曲': '第 2 面・深海のテーマ',
  '齿轮心脏': '歯車の心臓',
  '第三关·机械主题曲': '第 3 面・機械のテーマ',
  '光苔之森': '光苔の森',
  '第四关·森林主题曲': '第 4 面・森のテーマ',
  '幽影回廊': '幽影の回廊',
  '第五关·幽影主题曲': '第 5 面・幽影のテーマ',
  '星尘尽头': '星屑の果て',
  '第六关·星界主题曲': '第 6 面・星界のテーマ',
  '风暴王的仪仗': '嵐の王の儀仗',
  '云端 boss 主题曲': '雲上ボスのテーマ',
  '深渊的腕足': '深淵の腕足',
  '深海 boss 主题曲': '深海ボスのテーマ',
  '熔炉核心过载': '熔炉コア過負荷',
  '机械 boss 主题曲': '機械ボスのテーマ',
  '千年树人的怒号': '千年樹人の怒号',
  '森林 boss 主题曲': '森のボスのテーマ',
  '虚无之眼的凝视': '虚無の目の凝視',
  '幽影 boss 主题曲': '幽影ボスのテーマ',
  '星尘核心崩解': '星屑コア崩壊',
  '星界 boss 主题曲': '星界ボスのテーマ',
  '回廊巡礼': '回廊巡礼',
  '决战时刻': '決戦の刻',
  '云上凯旋式': '雲上の凱旋式',
  '过关结算结尾曲': 'クリア結果のエンディング',
  '谢幕后的星空': '幕引き後の星空',
  '制作名单主题曲': 'クレジットのテーマ',
  '标题画面的曲子。全长约 70 秒。C 利底亚调式 96 拍，主旋律交给了马林巴，像八音盒一样一颗一颗地响，底下是弦乐长音和低音提琴拨弦。从第二循环开始，一支长笛带着新的对位旋律加入进来——月亮升起来之后，总得有人陪它说话。写的时候满脑子是「今晚也要出发了」的感觉。': 'タイトル画面の曲。約 70 秒。C リディアン 96 拍、主旋律はマリンバ——オルゴールのように一音ずつ響き、下には弦楽のロングトーンとコントラバスのピチカート。2 ループ目からはフルートが新しい対位旋律で加わる——月が昇れば、話し相手が必要だから。書いている間ずっと「今夜も出発だ」という気持ちだった。',
  '第一关的曲子。全长约 84 秒，正好陪你跑完一趟云海。D 大调 148，主题交给单簧管，八分泵音拨弦贝斯带着经过音往前跑。曲式是变奏式发展：主题、对比、小高潮、再回到主题，织体一段一段加密，像云一层一层厚起来。小高潮（约 52 秒起）把主题整个抬高一个八度，是穿出云层忽然亮开的一瞬。全程节奏一致、无缝循环；过关的收束句交给了专门的结尾曲。毕竟是第一关，不设防地明亮到底。': '第 1 面の曲。約 84 秒、雲海をひとっ走りするのにぴったり。D 長調 148、テーマはクラリネット、八分のポンピング・ピチカートベースが経過音で先を行く。曲形式は変奏的展開：テーマ、対比、小さな山場、そしてテーマへ回帰。雲が重なるように織りが一段ずつ厚くなる。小さな山場（約 52 秒〜）でテーマが丸ごと一オクターブ上がる——雲を抜けて急に開ける瞬間。全編テンポ一定のシームレスループ。クリアの収束は専用エンディング曲に託した。第 1 面だから、無防備なほど明るく。',
  '第二关·深海的曲子。全长约 90 秒。A 多利亚调式 96，通篇三连音，摇摇晃晃像被水流推着走。主旋律是长笛——采样里自带的那点颤音，正好是水波的样子。音域收窄了，深海里不需要大起大落。零星的钟琴声是从海面上漏下来的、很远的光。': '第 2 面・深海の曲。約 90 秒。A ドリアン 96、全編三連符、水に押されるように揺れる。主旋律はフルート——サンプルに入ったわずかなビブラートが、ちょうど水の波のよう。音域は狭め、深海に大きな起伏はいらない。ところどころの鐘琴は、海面から漏れ落ちる遠い光。',
  '第三关·机械的曲子。全长约 87 秒。E 小调 165，核心是一条短促的切分 ostinato riff，两三个音像齿轮一样反复咬合，小号踩着切分节奏往前冲，底鼓四踩、拨弦贝斯十六分。高潮段 riff 整体抬高八度，流水线换挡提速。请小心不要被卷进去。': '第 3 面・機械の曲。約 87 秒。E 短調 165、核は短いシンコペのオスティナート・リフ——二三の音が歯車のように噛み合い、トランペットがシンコペで突き進み、キックは四つ打ち、ピチカートベースは十六分。クライマックスでリフが一オクターブ上がり、ラインがギアチェンジ。巻き込まれないように。',
  '第四关·森林的曲子。全长约 89 秒。G 利底亚调式 118，单簧管加附点节奏，蹦蹦跳跳的，像光斑在苔上跳。贝斯是低音提琴拨弦的 walking，一路经过音，和声用反拍断奏留出空隙给鸟叫（并没有真的录进去）。森林里迷路才是正事，走太快会错过蘑菇。': '第 4 面・森の曲。約 89 秒。G リディアン 118、クラリネットに付点リズム、苔の上の光斑みたいに跳ねる。ベースはコントラバスのピチカート・ウォーキング、経過音だらけ。和声はオフビートのスタブで鳥の声（実際は録っていない）に隙間を残す。森では迷うのが正しい楽しみ方——急ぐとキノコを見逃す。',
  '第五关·幽影的曲子。全长约 87 秒。D 弗里几亚调式的降二级一压下来，走廊就黑了。速度只有 88，音符之间留了很多空白——在这座回廊里，空白比声音更可怕。长笛贴着墙根走路，底鼓放慢成心跳，钟琴每隔一段才敲一下。请当作是为你敲的。': '第 5 面・幽影の曲。約 87 秒。D フリジアの降二級が落ちた瞬間、回廊は暗くなる。テンポは 88 のみ、音と音の間にたっぷりの空白——この回廊では、空白は音より怖い。フルートは壁際を歩き、キックは心拍に落ち、鐘琴は時折鳴るだけ。あなたのために鳴らしていると思ってほしい。',
  '第六关·星界的曲子。全长约 88 秒，终点前最后一段路。F# 小调 152，小号吹着长线条的旋律一句一句往上爬，底下是加宽到四个音的弦乐 pad 和 walking 拨弦贝斯，鼓放慢成半步感。小高潮来了两次，第二次更亮。抬头看看，星星都在为你让路。': '第 6 面・星界の曲。約 88 秒、終点前の最後の道。F# 短調 152、トランペットが長い旋律を一句ずつ登り、下は四音に広げた弦楽 pad とウォーキング・ピチカートベース、ドラムはハーフタイム感。小さな山場は二度来て、二度目はもっと明るい。見上げてみて、星々が道を譲ってくれている。',
  '云端 boss 的曲子。全长约 126 秒，展开→高潮→变奏再现，高潮埋在 36 秒左右。沿用第一关的 D 大调但提到 160，主角从单簧管换成小号——同一座云宫，道中听的是散步曲，王座前吹的是 fanfare。别被排场吓到，弹幕可比这个凶多了。': '雲上ボスの曲。約 126 秒、展開→クライマックス→変奏再現、山場は 36 秒あたり。第 1 面と同じ D 長調だが 160 に加速、主役はクラリネットからトランペットへ——同じ雲の宮殿でも、道中は散歩曲、玉座の前ではファンファーレ。格式に怯えるな、弾幕はもっと凶暴だ。',
  '深海 boss 的曲子。全长约 130 秒。三连音还在，但从摇篮变成了缠绕——克拉肯的腕足就是这种感觉吧。主旋律交给了长号，从深水底部往上压，鼓换成沉重的三拍连打，高潮在 38 秒附近浮出海面。这次的钟声听起来像沉船的钟。游泳圈请自备。': '深海ボスの曲。約 130 秒。三連符は残るが、揺りかごから絡みつきへ——クラーケンの腕足とはそういうものだ。主旋律はトロンボーン、深水の底から押し上げ、ドラムは重い三連打、クライマックスは 38 秒あたりで海面に浮上。今回の鐘は沈没船の鐘に聞こえる。浮き輪は持参のこと。',
  '机械 boss 的曲子。全长约 126 秒，175 仍是全曲库最快。切分底鼓加拨弦贝斯的低音脉冲一路碾压，小号是短促的四音呼喊，喊完就走，绝不多留。反拍断奏和双跳军鼓在后面追打，高潮约 38 秒处全线报警。建议在它冷却之前解决战斗。': '機械ボスの曲。約 126 秒、175 は依然全曲庫最速。シンコペのキックとピチカートベースの低音パルスが轢き進み、トランペットは短い四音の呼喊——叫んだら去る、絶対に留まらない。オフビートのスタブとダブルストロークのスネアが後から追い打ち、クライマックス約 38 秒で全線警報。冷める前に決着を。',
  '森林 boss 的曲子。全长约 128 秒。利底亚的明亮还在，但 142 的速度加反拍断奏，硬是把「散步」变成了「被树根追杀」。单簧管踩着附点节奏，那是树人跺脚的脚步声，钟琴像年轮一样一圈圈荡开。活了千年的东西发火，场面大概就是这样。': '森のボスの曲。約 128 秒。リディアンの明るさは残るが、142 の速度とオフビートのスタブで、「散歩」は「木の根に追われる」に変わる。クラリネットが付点リズムを踏む——それは樹人の足踏み、鐘琴は年輪のように広がる。千年生きたものが怒ると、だいたいこんな光景になる。',
  '幽影 boss 的曲子。全长约 122 秒。D 弗里几亚继续压暗，速度从关卡的 88 提到 118——那只眼睛盯过来的时候，心跳确实会快这么多。长笛的旋律稀疏得只剩注视，底鼓和军鼓放得很沉，钟琴一下一下，像敲在太阳穴上。别盯着它看太久。': '幽影ボスの曲。約 122 秒。D フリジアはさらに暗く、テンポは面の 88 から 118 へ——あの目がこちらを見たとき、心拍は確かにそれくらい上がる。フルートの旋律は凝視だけが残るほど疎になり、キックとスネアは重く沈み、鐘琴はこめかみに打つように一打一打。あまり長く見つめ返さないこと。',
  '最终 boss 的曲子。全长约 131 秒。多主题轮换：A 段全员齐奏断音，像核心外壳一层层碎裂；B 段换成高八度的流动旋律加宽幅弦乐 pad，八分对位像星图一样铺开。168 的速度、双主题的排场，高潮约 40 秒处核心开始崩解。打到这里的人，请把这首当作饯别礼。': '最終ボスの曲。約 131 秒。多テーマ輪番：A 段は全員のスタッカート、コアの殻が層ごとに割れるよう；B 段は高オクターブの流れる旋律に幅広い弦楽 pad、八分の対位が星図のように広がる。168 の速度、双テーマの格式、クライマックス約 40 秒でコアが崩れ始める。ここまで来た人へ、餞別の一曲を。',
  '额外关「终焉回廊」道中的曲子。全长约 82 秒，正好陪你走到王座门前。与 boss 曲「决战时刻」同用 B 弗里几亚调式——同一座回廊，道中是走向王座的脚步，王座前才是决战。速度压到 140（boss 曲 172），主旋律交给长笛蜿蜒而行，羽管键琴的十六分音像回廊深处不知疲倦的齿轮，远处的钟声一下一下，数着你还剩多少路。高潮埋在 41 秒左右，然后留一点空白——门就要开了。': 'エクストラ「終焉の回廊」道中の曲。約 82 秒、玉座の扉までちょうどいい。ボス曲「決戦の刻」と同じ B フリジア——同じ回廊、道中は玉座への足音、その先が決戦。テンポは 140 に抑え（ボス曲は 172）、主旋律はフルートが蛇行し、チェンバロの十六分は回廊の奥で倦まない歯車、遠い鐘が残りの道を数える。クライマックスは 41 秒あたり、そして少しの空白——扉が開く。',
  '额外关「终焉回廊」的主题曲，全长约 128 秒，写给单关 10 符卡连战的长夜。B 弗里几亚调式 172，小号加八分琶音，紧张感像公式一样叠满，展开→高潮→再现一座三连。曾经是通用 boss 兜底曲，如今转正为 Extra 专用——没有续关的回廊里，它就是唯一的仪仗。': 'エクストラ「終焉の回廊」のテーマ、約 128 秒、単面 10 スペルカード連戦の長い夜に。B フリジア 172、トランペットに八分のアルペジオ、緊張が公式のように積み上がる、展開→クライマックス→再現の三連。かつては汎用ボスの穴埋め曲、今や Extra 専用に昇格——コンティニューなしの回廊で、唯一の儀仗。',
  '过关结算时播放的结尾曲，全长约 10 秒，不循环，播完即止。D 大调 200，小号吹一句上行的 fanfare（I-IV-V-I 一路往上推），长音收束时弦乐对位和钟琴星点一起落下来。loop 曲目全程不再放慢——收束这件事，交给这首专门的曲子来做。': 'クリア結果で流れるエンディング曲、約 10 秒、ループなしで一度きり。D 長調 200、トランペットが上行のファンファーレ（I-IV-V-I と駆け上がる）、ロングトーンに収まるとき弦楽の対位と鐘琴の星屑が一緒に降る。ループ曲はもう終わりで遅くならない——収束はこの専用曲の仕事。',
  '制作名单场景的曲子，全长约 70 秒，为滚动的名字们而作。C 大调 96，长笛吹着长线条的旋律，弦乐 pad 铺底，鼓只留一点心跳似的脉冲，钟琴远远地敲。曲式走主题、对比、再回主题，结尾四句自然放慢收束——这首不作紧张 loop 用，慢一点没关系。仗打完了，该坐下来看看星星，顺便看看都是谁陪你打了这一仗。': 'クレジット画面の曲、約 70 秒、流れる名前たちのために。C 長調 96、フルートが長い旋律を歌い、弦楽 pad が敷き、ドラムは心拍のようなパルスだけ、鐘琴は遠くで鳴る。曲式はテーマ、対比、テーマ回帰、最後の四小節は自然に遅くなって収まる——緊張のループ用ではないから、ゆっくりでいい。戦いは終わった。座って星を見よう、誰が一緒に戦ってくれたかも、ついでに。',

  "我绕着自己打转，风就跟着我打转——一会儿左旋，一会儿右旋。看傻了可不行，涡流会把你一起卷进去的哦。": "わたしが回ると、風もいっしょに回るの——左にしばらく、それから右。ぼんやり見てると、渦に巻き込まれちゃうよ。",
  "台风里最安全的地方是风眼。我把风墙转着压过去，只给你留一个口——敢不敢钻进来，和我面对面？": "台風でいちばん安全なのは目の中。壁を回しながら押し寄せるから、隙間はひとつだけ——飛び込んで、わたしと向き合う勇気ある？",
  "云越积越厚，雨越下越急。我的积雨云从来不一次下完，它喜欢先试探，再倾盆。": "雲は積もるほど、雨は強くなる。わたしの積乱雲は一気に降らないの。まず試して、それからどっと降らせる。",
  "旋臂、花瓣、暴雨一齐上场的时候，连我自己都要让三分。这是天空的全力，你姑且当作天罚来躲吧。": "旋臂に花びら、豪雨まで全部のせ——さすがのわたしも少しは引くわ。空の全力よ。天罰だと思って避けなさい。",
  "雷不劈同一个地方？那是凡人的雷。我的落雷专挑你站的地方劈，半路还会拐弯。": "雷は同じ所に落ちない？それは人の雷よ。わたしの落雷はあなたの立つ場所を狙って、途中で曲がるの。",
  "暴风雨的终曲是一支圆舞。风往哪边转，雨就往哪边倒——跟上节拍，或者被我卷走。": "嵐の終曲は輪舞曲。風が向く方へ、雨も倒れていく——拍子に乗るか、巻き込まれるか。",
  "深海里没有光，除了我这一盏。灯火明明灭灭地飘过来，跟着光走的孩子，最后都到我嘴里来了。": "深海に光はない、わたしの灯りを除いては。明滅しながら漂ってくる灯りについてきた子は、みんなわたしのお口の中。",
  "沉下去的光是什么样子？大颗大颗，慢慢地开，像花在墨里绽。卷流会替我推你一把，别客气。": "沈んだ光はどんな姿？大粒のまま、ゆっくり咲く、墨の中の花みたい。潮流が押してあげるから、遠慮なく。",
  "我的腕足搅一搅，海就转起来了。卷向说变就变——海流听我的，不听你的。": "腕足でひとかきすれば、海が回りだす。巻く向きは気まぐれ——海流はあなたじゃなく、わたしの言うことを聞くの。",
  "深渊也会呼吸。一呼一吸，花都跟着涨落。你屏住呼吸没用，它又不听你的。": "深淵も呼吸をするの。吸って、吐いて——花がそれに合わせて開きしぼむ。あなたが息を止めても無駄よ、従わないから。",
  "浪一排一排压过来，缺口换来换去。被追上的话，就当我给你一个拥抱吧——用八条腕足。": "波が一列また一列と押し寄せて、抜け道はそのたび入れ替わる。捕まったら、八本の腕でハグしてあげる。",
  "见过大漩涡长出骨架的样子吗？旋臂是骨，卷流是肉。这张网撒出去，连我自己都收不回来。": "渦に骨格が生えたところ、見たことある？旋臂が骨、巻流が肉。この網を放ったら、わたし自身も戻せない。",
  "警告：本机封锁光束每五秒换向一次。规避窗口已计算完毕——不会告诉你的，自己算。": "警告：本機の封鎖ビームは五秒ごとに反転します。回避ウィンドウは計算済み——教えません。自分で計算してください。",
  "锯片臂数：三、四、五。转速：呼吸变速。警告：本机不对被切割者的体验负责。": "鋸アーム数：三、四、五。回転：呼吸変速。警告：本機は切断された側の体験について責任を負いません。",
  "听，咔、咔——停。齿轮咬两扣，歇一口气。这就是我心跳的声音，你跟得上吗？": "聞いて、カチ、カチ——止。歯車は二つ噛み合って、ひと息つく。これがわたしの心音。ついてこれる？",
  "温度上来了！旋臂越转越快，脉冲一圈比一圈密。炉心过载之前，要么你先退，要么我炸给你看。": "温度上昇！旋臂は速くなり、脈動の輪は密になる。炉心がオーバーロードする前に——引くか、爆発を見るか。",
  "导弹一旦锁定，只会越咬越死，甩是甩不掉的。唯一的办法是别站着不动——虽然是废话。": "ミサイルは一度ロックオンすれば、どんどん深く食い込む。振り切れない。動き続けるだけ——当然だけど。",
  "大齿轮小齿轮一起甩出去，离心力把它们掰成弯的。流水线嘛，偶尔也出点飞件。": "大きな歯車も小さな歯車もいっしょに放り出して、遠心力で曲げる。ラインにもたまには飛び出す部品があるの。",
  "我的孩子们乘风去旅行，落在哪儿，就在哪儿住下。你也当心，别让它们落在你身上。": "わたしの子たちは風に乗って旅をして、落ちた場所に住みつくの。あなたも気をつけて——あなたの上に落ちないように。",
  "菌毯醒来的时候，花一丛一丛地开，孢子像雨一样落。踩过我的地毯，总要付出点代价。": "菌絨が目覚めるとき、花はあちこちで咲き、胞子は雨のように降る。わたしの絨毯を踏んだなら、代価を払ってもらう。",
  "藤蔓不急。它先围起来，再把缺口一个个挪开。一千年了，没有谁跑得过耐心。": "蔦は急がない。まず取り囲んで、それから抜け道をひとつずつずらす。千年の間、忍耐に勝った者はいない。",
  "把手放在地上，你摸到的就是它的脉。一胀，一缩。我的根，比你想象的走得远。": "大地に手を置いてごらん——その脈がわたしのもの。膨らんで、縮む。根は思っているより遠くまで届く。",
  "落叶也会跳舞，转够了就换个方向。年轻人，别光看叶子好看——舞池里是不能停脚的。": "落ち葉も踊るのよ、回り終わったら向きを変えて。若い人、葉っぱに見とれてないで——舞踏場で立ち止まっちゃだめ。",
  "林子里的小东西喜欢你，会一直跟着你。花开了又谢，谢了又开——它们可不懂什么叫客气。": "森の小さな子たちはあなたが好きで、ずっとついていくの。花は咲いては散り、散っては咲く——遠慮というものを知らないの。",
  "提灯一晃，鬼火就飘过去了。忽明忽暗，才是引路的样子嘛。跟紧哦——跟丢了可不怪我。": "提灯をひと振りすれば、鬼火が漂っていく。明滅してこそ、案内役らしいでしょ。ついてきて——迷子になっても知らないよ。",
  "夜行的队伍出发咯。小鬼火三三两两地走，走得慢的可别掉队。哎呀，你也在队伍里吗？": "夜行の行列、出発よ。小さな鬼火が二つ三つと並んで歩く。遅れる子は置いていくよ。あら、あなたも行列に入ってるの？",
  "海没有光，一波一波地涨。你在里面能看见什么？什么都看不见，除了我在看你。": "光のない海、一波また一波と満ちていく。そこで何が見える？何も——わたしがあなたを見ている以外は。",
  "被盯着的东西会越转越快。我的视线不拐弯，我的弹幕会。眨眼，就算你输。": "見つめられたものは、どんどん速く回る。わたしの視線は曲がらない。でも弾幕は曲がる。瞬きしたら、あなたの負け。",
  "紫色，蓝色，紫色，蓝色。虚无没有颜色，所以什么颜色都可以是。沉进去吧。": "紫、青、紫、青。虚無に色はないから、どんな色でもいい。沈みなさい。",
  "夜落下来的时候，连弹幕都会被压弯。换个方向，再压一次。永夜的意思就是：不会天亮。": "夜が降りるとき、弾幕さえ押し曲げられる。向きを変えて、もう一度。永夜というのは——明けない夜のこと。",
  "彗星过境，尾迹会留下来陪你玩。小心，它们还会在半空碎成星尘——优雅，但是危险。": "彗星が通り過ぎると、尾跡が残って遊んでくれる。気をつけて、空中で星屑に砕けるから——優雅だけど、危険よ。",
  "正面接下我的陨星雨吧！砸下来还不算完，碎了还要再追你一段。骑士的问候，从来不只一下。": "隕星の雨を正面から受け止めなさい！落ちて終わりじゃない、砕けてさらに追いかけてくる。騎士の挨拶は一度きりじゃない。",
  "银河就这样转了一百亿年，快一阵，慢一阵。你倒是第一个想从旋臂里穿过去的。": "銀河はこうして百億年回ってきた、速くなったり遅くなったり。旋臂を抜けようとしたのは、あなたが初めてよ。",
  "恒星燃尽的时候会换一种颜色，再换一种颜色。看好了——这是我最亮的样子。": "燃え尽きる星は色を変え、また変える。よく見て——これがいちばん輝くわたし。",
  "宇宙到最后会往回收。反着转，缩着走，所有花样一起来。能见证这一幕，你运气不错。": "宇宙は最後に内へ収縮する。逆回転、縮む輪、全部のせ。目撃できて、運がいいわね。",
  "一点星火，被热浪卷成环，碎开来就是一片原。燃烧这种事，我最懂了。": "ひとつの星火が、熱波で輪に巻かれ、砕けて燎原になる。燃やすことなら、わたしがいちばん詳しい。",
  "回廊的规矩第一条：先接住星屑。旋臂转着，礼花开着——欢迎来到终焉回廊。": "回廊の掟その一：まず星屑を受け止めなさい。旋臂が回り、礼花が開く——終焉回廊へようこそ。",
  "流星一旦认出你，就会一直追。追上之前，还会在半空开花。被星星喜欢，是要付出代价的。": "流星はあなたを覚えると、ずっと追いかける。追いつく前に、空中で花開く。星に好かれるには代償がいるの。",
  "十字封场，来回地扫。回廊里没有死角，只有还没扫到的地方。": "十字に封じて、往復に掃く。回廊に死角はない——まだ掃かれていない場所があるだけ。",
  "直来直去的回廊多没意思。我把它卷起来——墙还是那堵墙，路可不是那条路了。": "まっすぐな回廊なんてつまらない。巻き上げてしまう——壁は同じでも、道はもう別物よ。",
  "舞会开始了。灯球转着，舞步越跳越快。踩错一拍？那就当给我助兴了。": "舞踏会の始まりよ。ミラーボールが回り、ステップはどんどん速く。一拍外した？それはわたしへの余興ってことで。",
  "借来的地毯，意外地好用。孢子在回廊里扎了根，一圈一圈地等你。——谢啦，菇后。": "借り物の絨毯、思いのほか使い勝手がいいの。胞子が回廊に根づいて、輪になって待ってる。——ありがと、茸の女王。",
  "蛇会走直线吗？矩阵会扭吗？在我这里都会。扭的幅度嘛，看我心情。": "蛇はまっすぐ進める？行列はくねる？ここでは両方ともくねるの。くねる幅は、わたしの気分次第。",
  "终焉第一幕：全弹发射。青的紫的一起来，转够八秒换一边。撑住，这才刚开始。": "終焉第一幕：全弾発射。青と紫がいっしょに、八秒ごとに反転。耐えて——まだ始まったばかりよ。",
  "星链一扣一扣地锁，墙一排一排地围。咔、咔——停。你猜，下一扣锁在哪里？": "星の鎖は一環ずつ、壁は一列ずつ。カチ、カチ——停。さあ、次の環はどこに落ちる？",
  "最后一幕，星灵全开。花按彩虹的顺序开，蛇形按着呼吸扭。过了这关，回廊就没有秘密了。": "最終幕、星霊全開。花は虹の順に咲き、蛇は呼吸に合わせてくねる。これを抜ければ、回廊に秘密はもうない。",

  "何人在寡人的云海踏浪？风都替你紧张起来了。": "誰よ、わたしの雲海で波を踏んでるのは？風もあなたを心配してるわ。",
  "我叫开开心！借你的云打个招呼——弹幕，来啦！": "あたしはカイカイ！雲を借りてご挨拶——弾幕、いくよー！",
  "过路。让开。": "通りすがり。どいて。",
  "挡路的？正好，我手痒了！": "邪魔者？ちょうどいい、腕がうずいてた！",
  "那、那个……我只是路过……呜……": "あ、あの……通りすがりなだけ……うぅ……",
  "咦？云……成精了？": "あれ？雲が……化けた？",
  "路过顺便给你加个油——然后打一架！": "通りすがりに応援してあげる——それから勝負！",
  "唔……好软的云……能睡个午觉吗……": "んー……ふかふかの雲……昼寝していい……？",
  "萌萌路过~大个子你会比心吗？": "萌萌通りまーす～大きい人、ハート作れる？",
  "只是路过的弹幕使。借过。": "通りすがりの弾幕使いよ。ごめんなさいね。",
  "借过？云海没有路，只有风向。逆着寡人的风，半步也休想。": "ごめんなさいね、だって？雲海に道はない、風向きだけ。わたしの風に逆らって、半歩も進めないわ。",
  "那我就顺着你的风跳个舞给你看！": "じゃあその風に乗って、踊ってあげる！",
  "风会停。你不会赢。": "風は止む。あなたは勝てない。",
  "我把你的风全打回去！": "その風、全部吹き返してやる！",
  "对不起对不起……但、但是我不能退……！": "ご、ごめんなさい……で、でも引けないの……！",
  "风……往哪边吹来着？": "風って……どっちに吹くんだっけ？",
  "风向什么的，看我的气势把它吹回去！": "風向きなんか、気合で吹き返してみせる！",
  "逆风……好困……快点打完吧……": "向かい風……眠い……早く終わらせよ……",
  "风再大，也吹不走我的可爱~": "どんな風でも、あたしの可愛さは飛ばせないよ～",
  "那我只好自己开一条路了。": "じゃあ自分で道を作るだけ。",
  "好胆色。那就让积雨云看看——你能接住几滴天罚。": "いい度胸ね。なら積乱雲に見せてもらおう——天罰の雫、いくつ受け止められるか。",
  "水面上的客人……是灯的甜味引你下来的吗？": "水面からの客人……灯りの甘さに誘われてきたの？",
  "是你的派对灯光太好看啦！带我一个！": "パーティーの灯りが綺麗すぎ！混ぜて！",
  "你的灯，太晃眼。": "その灯り、眩しすぎ。",
  "少废话！上来就打！": "無駄口！さっさと戦え！",
  "呜……这里好黑……你的灯可以借我一下吗……": "うぅ……ここ暗い……その灯り貸して……",
  "咦，是你约我下来的吗？": "あれ、誘ってくれたの？",
  "深海巡游第一站！克拉肯，接招！": "深海ツアー最初の駅！クラーケン、食らえ！",
  "水里好舒服……想边睡边打……": "水の中気持ちいい……寝ながら戦おう……",
  "哇，八条腿！可以帮我扎头发吗？": "わあ、八本足！髪編んでくれる？",
  "我只是追着弹幕的轨迹下来的。": "弾幕の軌跡を追ってきただけよ。",
  "深海没有甜，只有压。你的骨头会先替我尝到。": "深海に甘さはない、あるのは圧だけ。あなたの骨が先に味わうわ。",
  "压强什么的，笑着就顶住啦！": "水圧なんて、笑って耐えてみせる！",
  "我的枪比你的压更重。": "あたしの銃は、あんたの圧より重い。",
  "看我把你煮成章鱼烧！": "たこ焼きにして食べてやる！",
  "骨、骨头会断掉吗……好可怕……但我不走！": "ほ、骨が折れちゃう……？怖い……でも逃げない！",
  "压？是哪一种压？": "圧？どの圧？",
  "我的热血，深海也煮得沸！": "あたしの熱血、深海でも沸かしてみせる！",
  "压一压……更好睡……": "圧がかかると……よく眠れる……",
  "压力讨厌~萌萌要浮起来！": "圧なんて嫌～萌萌は浮かぶの！",
  "那就比比谁先被压垮。": "じゃあどっちが先に潰れるか、勝負。",
  "有趣。腕足已张开——这场拥抱，你躲不掉。": "面白い。腕は開いた——この抱擁からは逃がさない。",
  "警告：核心区域，非授权单位。立即停机，接受熔解。": "警告：コア区域、許可されていないユニット。直ちに停止し、溶解を受け入れよ。",
  "拒绝停机！我还要去玩呢！": "停止拒否！まだ遊びに行くんだもん！",
  "授权？我就是。": "許可？あたしがそう。",
  "熔解？！我先把你拆了卖废铁！": "溶解？！先にバラして鉄くずにしてやる！",
  "对、对不起，我这就走……咦，走不掉？": "ご、ごめんなさい、すぐ出ます……あれ、出られない？",
  "停机……是按哪个钮？": "停止……どのボタン？",
  "检测报告：你这炉子火力不足！": "検査報告：この炉、火力不足！",
  "停机……好耶……那我可以睡了吗……": "停止……やった……じゃあ寝ていい……？",
  "熔解好可怕~萌萌会化掉的！": "溶解怖い～萌萌が溶けちゃう！",
  "我只是借道的，不打算停机。": "通りすがりなだけ。停止する予定はないわ。",
  "借道申请驳回。本炉每分钟熔解借道单位十二个。": "通行申請、却下。本炉は通行ユニットを毎分十二個溶解する。",
  "那我做第十三个——特别难熔的那种！": "じゃあ十三個目になる——特別溶けにくいやつ！",
  "你的产量，今天归零。": "その生産数、今日ゼロになる。",
  "才十二个？我一个顶一百个！": "たった十二個？あたしは百個分だよ！",
  "呜……我不想被熔解……我要回家……": "うぅ……溶かされたくない……おうち帰りたい……",
  "十二个……那第十三个免费吗？": "十二個……十三個目は無料？",
  "熔解之前，先尝尝我的热血！": "溶かされる前に、熱血を味わえ！",
  "十二个……数着数着就困了……": "十二個……数えてたら眠くなってきた……",
  "驳回无效~萌萌的票是永久的！": "却下無効～萌萌の切符は永久有効！",
  "那今天这个数字到你为止。": "じゃあ今日その数字はお前で止まる。",
  "炉心升温。链齿咬合——开始熔解程序。": "炉心加温。ギア噛合——溶解プロトコル開始。",
  "慢些。再慢些。你听，腐叶下面，都是千年的根。": "ゆっくり。もっとゆっくり。聞こえる？腐れ葉の下、千年の根っこ。",
  "树爷爷好！你的叶子我能捡一片吗？": "樹のおじいちゃん、こんにちは！葉っぱ一枚もらっていい？",
  "让路，老树。": "どけ、老い樹。",
  "千年？烧掉只要十分钟！": "千年？燃やすのは十分だけ！",
  "对、对不起……我踩疼你的根了吗……": "ご、ごめんなさい……根っこ踏み痛めた……？",
  "根……在跟我说话？": "根っこが……話してる？",
  "千年古树！值得我全力一战！": "千年の古樹！全力で戦う価値あり！",
  "千年……那你一定很困吧……": "千年……じゃあきっと眠いよね……",
  "树爷爷，萌萌可以在这里野餐吗？": "樹のおじいちゃん、萌萌ここでピクニックしていい？",
  "久仰。我只是路过的客人。": "ご機嫌よう。通りすがりの客人よ。",
  "客人踩断了三根细根。千年了，我学会的第一课，就是不再原谅。": "客人は細い根を三本折った。千年かけて最初に学んだのは、許すのをやめることだ。",
  "那我赔你一场热闹！森林最喜欢热闹了！": "じゃあ賑やかさで返すね！森は賑やかなのが大好き！",
  "我数着的。两根。": "数えてた。二本。",
  "才三根？我让你断三千根！": "たった三本？三千本折ってやる！",
  "呜哇——对不起！我、我给你浇水！": "うわあ——ごめんなさい！お、お水あげる！",
  "三根……是左边那三根吗？": "三本……左の三本？",
  "那我用全力道歉——全力一战！": "じゃあ全力で謝る——全力の一戦で！",
  "原谅我嘛……我只是想睡觉……": "許して……ただ昼寝したいだけ……",
  "萌萌这么轻，怎么会断呢~？": "萌萌は軽いから、折れるわけないよ～？",
  "那我只好用胜利道歉了。": "じゃあ勝利で謝ることにする。",
  "藤蔓不急。它有一整个下午，把你留在这里。": "蔦は急がない。午後いっぱいかけて、あなたをここに留める。",
  "你看得见我吗？这里很暗。暗到只剩我在看你。": "わたしが見える？ここは暗い。わたしが見ていることだけが残るほどに。",
  "看得见呀！这么大一只眼睛，想看不见都难！": "見えるよ！こんな大きな目、見えない方が難しい！",
  "看够了就闭眼。": "見飽きたら閉じろ。",
  "看什么看！把你打成瞎子！": "何見てる！盲にしてやる！",
  "呜……被盯着看……好可怕……": "うぅ……見つめられてる……怖い……",
  "咦，是谁在说话？": "あれ、誰が話してるの？",
  "那就看看我的光！亮瞎你！": "じゃああたしの光を見ろ！眩しくて目潰しよ！",
  "黑黑的……正好睡觉……": "暗い……ちょうど寝れる……",
  "萌萌这么可爱，看个够吧~": "萌萌は可愛いから、いくらでも見ていいよ～",
  "彼此彼此。": "お互い様よ。",
  "每个进来的人都这么说。他们最后都把眼睛留在了这里。": "入ってくる者は皆そう言う。最後には皆、目をここに残していった。",
  "眼睛才不给你！我还要用它看明天的太阳！": "目はあげない！明日の太陽を見るのに使うもん！",
  "试试。": "やってみろ。",
  "我把你的眼睛挖出来陪葬！": "その目を抉り出して、棺の供え物にしてやる！",
  "不、不要！我的眼睛还要留着哭……": "い、嫌！あたしの目は泣くためにあるの……",
  "留眼睛……怎么留？": "目を残す……どうやって？",
  "我的视线是燃着的——拿不住！": "あたしの視線は燃えてる——持ちきれないよ！",
  "眼睛给你……眼皮给我留下……": "目玉はあげる……まぶたは残して……",
  "不给~萌萌要眼睛来卖萌的！": "あげない～萌萌はその目で卖萌するの！",
  "你留不住我的。": "あたしのは留められない。",
  "那现在，换我仔细看看你——别眨眼。": "では今度は、わたしがじっくり見る番——瞬きするな。",
  "旅人，你走到了星屑的尽头。再往前，就是终焉。": "旅人よ、星屑の果てに辿り着いたな。この先は終焉だ。",
  "终焉？听起来像最后一关！那我更要冲了！": "終焉？最終面ってこと！なおさら突っ込む！",
  "终焉见多了。让开。": "終焉は見慣れた。どけ。",
  "终焉？！我先把你终焉了！": "終焉？！お前を終焉させてやる！",
  "终、终焉……听起来好可怕……但我不能回头……": "しゅ、終焉……怖そう……でも戻れない……",
  "咦？这里就是最后一关吗？": "あれ？ここが最終面？",
  "燃烧到星屑的尽头——正合我意！": "星屑の果てまで燃える——思い通りだ！",
  "终焉……打完就能睡了吧……": "終焉……倒したら寝ていい……？",
  "终焉是什么？能吃吗？": "終焉って何？食べられる？",
  "那就把终焉变成我的终点线。": "じゃあその終焉を、あたしのゴールにしてやる。",
  "星尘核心的每一次脉动，都是一个世界的余烬。你要以肉身贴近它？": "星塵コアの鼓動ひとつひとつが、世界の燃え殻。生身で近づくつもりか？",
  "余烬也是光呀！我来替你点亮下一把火！": "燃え殻も光だよ！次の火を点けてあげる！",
  "我贴近过的核心，不止你一个。": "近づいたコアは、お前だけじゃない。",
  "脉动？打爆了就不脉了！": "鼓動？爆破したら止まるよ！",
  "余、余烬会烫吗……呜……但我不会退！": "も、燃え殻は熱い……？うぅ……でも退かない！",
  "贴近？多远算贴近？": "近づくって、どれくらい？",
  "我的血也是余烬燃的！比比谁烫！": "あたしの血も燃え殻で燃えてる！どっちが熱いか勝負！",
  "余烬……暖烘烘的……适合睡觉……": "燃え殻……ぽかぽか……寝やすい……",
  "余烬也要萌萌地烧！": "燃え殻も萌萌に燃やそう！",
  "贴近了，才能打穿它。": "近づかなきゃ、撃ち抜けない。",
  "那么——银河回旋，为你让路。前提是，你过得去。": "では——銀河の渦、道を開けよう。通れれば、の話だが。",
  "回廊的考官见过许多来客。走到王座前的，你是第一个。": "回廊の試験官は多くの客を見てきた。玉座に辿り着いたのは、お前が初めてだ。",
  "第一个？那我要拿满分！": "最初？じゃあ満点取る！",
  "考官？我只带枪来。": "試験官？あたしは銃だけ持ってきた。",
  "少摆架子！你的题我全拆了！": "偉そうに！問題全部壊してやる！",
  "考、考试？我没复习……呜……": "し、試験？勉強してない……うぅ……",
  "咦？要考试吗？考什么？": "あれ？試験？何の試験？",
  "毕业考是吧！看我的热血答卷！": "卒業試験か！熱血の答案を見ろ！",
  "考完……就能睡了吧……": "試験が終わったら……寝ていい……？",
  "考官老师~可以开卷吗？": "先生～持ち込みあり？",
  "第一个，但不会是最后一个。": "最初だけど、最後じゃない。",
  "十道符卡，没有续关。答错一题，就留在回廊里当星屑。": "スペルカード十問、コンティニューなし。一問間違えば、回廊の星屑になる。",
  "十道全对！星屑还是留给你自己吧！": "十問全問正解！星屑は自分で持ってな！",
  "出题吧。": "出題しろ。",
  "一题都不会错！错了我把回廊烧了！": "一問も間違えない！間違えたら回廊を燃やす！",
  "不、不要当星屑……我要回家……": "ほ、星屑になりたくない……おうち帰りたい……",
  "星屑……和星星是亲戚吗？": "星屑って……お星さまの親戚？",
  "十道而已！我的热血够答一百道！": "たった十問！あたしの熱血は百問答える！",
  "十道……数着数着就困了……": "十問……数えてたら眠く……",
  "萌萌的答案都是满分答案~": "萌萌の答えは全部満点だよ～",
  "那就一题一题打过去。": "じゃあ一問ずつ倒していく。",
  "很好。终焉回廊，开考。": "よし。終焉回廊、開幕。",

  "环波 3 波 + 每波 10 向子机齐射": "リング波3連＋各波10方向オプション斉射",
  "2 波心形追踪弹（每波 6 颗）锁定敌人": "ハート追尾弾2波（各6発）が敵をロックオン",
  "思维混乱": "思考混乱",
  "4s 内屏上敌弹方向错乱（随机摆动）": "4秒間、敵弾が方向を見失う（ランダム揺動）",
  "全屏敌弹 50% 变成点道具（上限 300 颗）": "全画面の敵弾50%を点アイテムに変える（上限300個）",
  "0.8s 无敌并向前瞬移一段距离": "0.8秒無敵で前方へ瞬間移動",
  "睡遁": "睡遁",
  "6s 射速×1.6、伤害×1.3": "6秒間 射速×1.6、ダメージ×1.3",
  "8s 子机火力×2 + 自机移速×1.15": "8秒間 オプション火力×2＋自機移速×1.15",
  "诶…？": "え…？",

  "2s 连环分区爆破：每爆清一区并伤敌（伪全屏）": "2秒連続エリア爆破：爆破ごとに一エリアを一掃しダメージ（擬似全画面）",

  "额外关·终焉回廊": "エクストラ「終焉の回廊」",
  "额外关  终焉回廊": "エクストラ  終焉の回廊",
  "额外关 CLEAR!!": "エクストラ CLEAR!!",
  "额外关道中主题曲": "エクストラ道中のテーマ",
  "额外关 boss 主题曲": "エクストラボスのテーマ",

};
